import { AddCardToBinderOptionsSkeleton } from "../AddCardToBinderOptions/AddCardToBinderOptionsSkeleton";
import { Skeleton } from "@/components/ui/skeleton";
import { AddCardToBinderBindersInputSkeleton } from "../AddCardToBinderBindersInput/AddCardToBinderBindersInputSkeleton";
import { AddCardToBinderQuantityInputSkeleton } from "../AddCardToBinderQuantityInput/AddCardToBinderQuantityInputSkeleton";

export function EditCardInBinderDialogSkeleton() {
  return (
    <div className="grid gap-4">
      <AddCardToBinderOptionsSkeleton />
      <AddCardToBinderOptionsSkeleton />
      <AddCardToBinderOptionsSkeleton />
      <div className="grid gap-2">
        <Skeleton className="h-5 w-28" />
        <Skeleton className="h-10 w-full" />
      </div>
      <div className="grid gap-2">
        <Skeleton className="h-5 w-28" />
        <AddCardToBinderQuantityInputSkeleton />
      </div>
      <div className="grid gap-2">
        <Skeleton className="h-5 w-28" />
        <AddCardToBinderBindersInputSkeleton />
      </div>
    </div>
  );
}
